import React, { Component } from 'react';
import { Modal, Radio, message } from 'antd';
import API_URL from '../../../common/url';
import addToDownloadSite from '../../shared/addToDownloadSite';

const RadioGroup = Radio.Group;

class ExportModal extends Component {
    state = {
        visible: false,
    }

    show = (searchParams) => {
        this.setState({
            flag: '',
            searchParams,
            visible: true,
        });
    }

    handleOk = () => {
        const { flag, searchParams } = this.state;
        if (flag === '') {
            message.warning('请选择项目明细导出方式');
            return;
        }

        addToDownloadSite({ flag, ...searchParams }, API_URL.hospital.exportDoctorListByInves, flag == 1 ? 'DOCTOR_AREA' : 'DOCTOR_GROUP');
        this.setState({ visible: false });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ flag: e.target.value });
    }

    render () {
        const { visible, flag } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label" style={{ marginLeft: -15 }}>请选择项目明细导出方式</label>
                            </div>
                            <div className="item" style={{ width: '65%' }}>
                                <RadioGroup onChange={this.onChange} value={flag}>
                                    <Radio value={0}>按医生分组导出</Radio>
                                    <Radio value={1}>按项目领域分组导出</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/ExportModal.js